import React from "react";
import { Fragment } from "react";
import { lazyWithRetry } from "../../core/lazy_with_retry";

import { CapacityOption } from "../template_offering_listing_base";
import { TemplateOfferingListingMeetingRoom } from "../template_offering_listing_meeting_room";
import { useTheYardAnalytics } from "./theyard_analytics";
import { partnerConfig } from "./theyard_partner_config";

const Theme = lazyWithRetry(() => import("./theyard_theme"));

const capacityOptions: CapacityOption[] = [
  { label: "1 - 10", value: { minCapacity: 1, maxCapacity: 10 } },
  { label: "10+", value: { minCapacity: 11 } },
];

export function OfferingTheYardListingMeetingRoom() {
  useTheYardAnalytics();

  return (
    <Fragment>
      <Theme />
      <TemplateOfferingListingMeetingRoom
        filterConfig={{ capacity: true, location: true, capacityOptions }}
        partnerConfig={partnerConfig}
        data={{
          title: "Meeting Rooms",
          description:
            "Host meetings and re-group with the team in our tech-enabled conference rooms.",
        }}
      />
    </Fragment>
  );
}
